export default __webpack_public_path__ + "static/media/sem-info.d92fdae5.svg";